<template>
    <div class="col-lg-6 col-md-6 col-sm-12 col-12 connexion-right-aelp">
        <div class="connexion-right-in-aelp">
            <div class="connexion-box-main-aelp">
                <div class="common-title-main-aehp common-title-center-aehp">
                    <h2>Espace Assuré</h2>
                </div>
                <div class="connexion-options-aelp" style="text-align: left; padding: 20px;">
                    <p style="margin-bottom: 15px;"><strong>Chers assurés,</strong></p>
                    
                    <p style="margin-bottom: 15px;">
                        Nous vous informons qu'AGEMI n'assure désormais plus de gestion des sinistres.
                    </p>
                    
                    <p style="margin-bottom: 15px;">
                        En conséquence, il n'est plus possible d'effectuer de <strong>déclaration de sinistre en ligne</strong> sur cette plateforme.
                    </p>
                    
                    <p style="margin-bottom: 15px;">
                        👉 <strong>Rassurez-vous :</strong> l'ensemble des dossiers en cours a été transmis à votre assureur, accompagné de toutes les informations nécessaires à la poursuite de leur traitement, afin d'assurer une <strong>continuité complète du suivi</strong> de vos demandes.
                    </p>
                    
                    <p style="margin-bottom: 15px;">
                        Désormais, pour toute <strong>nouvelle déclaration</strong> ou pour le <strong>suivi d'un dossier existant</strong>, nous vous invitons à contacter directement votre assureur :
                    </p>
                    
                    <div style="margin-left: 20px; margin-bottom: 15px;">
                        <p style="margin-bottom: 8px;">
                            <strong>AXA :</strong> <a href="mailto:service.dovdf@axa.fr">service.dovdf@axa.fr</a> / <a href="mailto:service.vdfpolyvalent@axa.fr">service.vdfpolyvalent@axa.fr</a>
                        </p>
                        <p style="margin-bottom: 8px;">
                            <strong>ERGO :</strong> <a href="mailto:sinistresergo@acsservices.eu">sinistresergo@acsservices.eu</a> / <a href="mailto:sinistres@ergo-industrial.fr">sinistres@ergo-industrial.fr</a>
                        </p>
                        <p style="margin-bottom: 8px;">
                            <strong>QBE :</strong> <a href="mailto:qbesindo@stelliant.com">qbesindo@stelliant.com</a> / <a href="mailto:qbesinrc@stelliant.com">qbesinrc@stelliant.com</a>
                        </p>
                    </div>
                    
                    <p style="margin-bottom: 15px;">
                        Merci de votre confiance.
                    </p>
                    
                    <p style="margin-bottom: 15px;">
                        <strong>L'équipe AGEMI</strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Choice'
}
</script>
